import http from '../request'
// 获取书籍列表数据
export const getBookList = params => {
  return http.get('/api/home/book', { params })
}
// 获取书籍列表数据
export const getHomeTotal = params => {
  return http.get('/api/home/book/countData', { params })
}
//访问量  /api/home/visits/updateAndFindVisits
export const visit = () => {
  return http.get('/api/home/visits/updateAndFindVisits')
}
// about /api/home/aboutUs
export const getAbout = () => {
  return http.get('/api/home/aboutUs')
}
